function r(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(r, t).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function t(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? r(Object(n), !0).forEach(function (r) {
      u(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function e(r, t, e, n, o, a, i) {
  try {
    var u = r[a](i),
      l = u.value;
  } catch (r) {
    return void e(r);
  }
  u.done ? t(l) : Promise.resolve(l).then(n, o);
}
function n(r) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (o, a) {
      var i = r.apply(t, n);
      function u(r) {
        e(i, o, a, u, l, "next", r);
      }
      function l(r) {
        e(i, o, a, u, l, "throw", r);
      }
      u(void 0);
    });
  };
}
function o(r, t) {
  if (!(r instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function a(r, t) {
  for (var e = 0; e < t.length; e++) {
    var n = t[e];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function i(r, t, e) {
  return t && a(r.prototype, t), e && a(r, e), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function u(r, t, e) {
  return t in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
function l() {
  return l = Object.assign || function (r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }, l.apply(this, arguments);
}
function c(r, t) {
  if (null == r) return {};
  var e,
    n,
    o = function (r, t) {
      if (null == r) return {};
      var e,
        n,
        o = {},
        a = Object.keys(r);
      for (n = 0; n < a.length; n++) e = a[n], t.indexOf(e) >= 0 || (o[e] = r[e]);
      return o;
    }(r, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(r);
    for (n = 0; n < a.length; n++) e = a[n], t.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(r, e) && (o[e] = r[e]);
  }
  return o;
}
function f(r, t) {
  return function (r) {
    if (Array.isArray(r)) return r;
  }(r) || function (r, t) {
    var e = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null == e) return;
    var n,
      o,
      a = [],
      i = !0,
      u = !1;
    try {
      for (e = e.call(r); !(i = (n = e.next()).done) && (a.push(n.value), !t || a.length !== t); i = !0);
    } catch (r) {
      u = !0, o = r;
    } finally {
      try {
        i || null == e.return || e.return();
      } finally {
        if (u) throw o;
      }
    }
    return a;
  }(r, t) || s(r, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function y(r) {
  return function (r) {
    if (Array.isArray(r)) return b(r);
  }(r) || function (r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }(r) || s(r) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function s(r, t) {
  if (r) {
    if ("string" == typeof r) return b(r, t);
    var e = Object.prototype.toString.call(r).slice(8, -1);
    return "Object" === e && r.constructor && (e = r.constructor.name), "Map" === e || "Set" === e ? Array.from(r) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? b(r, t) : void 0;
  }
}
function b(r, t) {
  (null == t || t > r.length) && (t = r.length);
  for (var e = 0, n = new Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function p(r, t) {
  var e = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!e) {
    if (Array.isArray(r) || (e = s(r)) || t && r && "number" == typeof r.length) {
      e && (r = e);
      var n = 0,
        o = function () {};
      return {
        s: o,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: o
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a,
    i = !0,
    u = !1;
  return {
    s: function () {
      e = e.call(r);
    },
    n: function () {
      var r = e.next();
      return i = r.done, r;
    },
    e: function (r) {
      u = !0, a = r;
    },
    f: function () {
      try {
        i || null == e.return || e.return();
      } finally {
        if (u) throw a;
      }
    }
  };
}
export { f as _, t as a, u as b, i as c, o as d, n as e, y as f, c as g, l as h, p as i };